import type { Regions } from '@mentimeter/http-clients';
import { DEFAULT_REGION } from './utils';

const REGIONAL_INVITE_TOKEN_LENGTH = 38;

const getRegionByPrefix = (key: string): Regions => {
  const prefix = key.substring(0, 2);
  if (prefix === 'eu') {
    return 'eu';
  }
  if (prefix === 'us') {
    return 'us';
  }
  return DEFAULT_REGION;
};

export const getRegionFromInviteToken = (token: string): Regions => {
  if (token.length === REGIONAL_INVITE_TOKEN_LENGTH) {
    return getRegionByPrefix(token);
  }
  return DEFAULT_REGION;
};
